import PosthogService from '~/services/posthog/PosthogService';

export interface IScheduleListInviteClickedPayload {
  shiftId: string;
}

/**
 * Fires when the user clicks "Invite" from the Schedule List view
 * Event: dental_portal:schedule_list:invite_clicked
 */
export function fireScheduleListInviteClicked(payload: IScheduleListInviteClickedPayload): void {
  PosthogService.getInstance().track('dental_portal:schedule_list:invite_clicked', {
    invite_type: 'Existing Shift',
    shift_id: payload.shiftId,
  });
}
